import { Aggregator } from "../types";
import { BehaviorSubject } from "rxjs";

export class PdfImgCollector implements Aggregator<HTMLImageElement> {
    public imagesCache: HTMLImageElement[] = [];
    private currentIndex = 1;

    public hasRenderFinished: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public add(img: HTMLImageElement): void {
        this.imagesCache.push(img);
    }

    public getCurrent(): HTMLImageElement {
        if(this.imagesCache[this.currentIndex]) {
            return this.imagesCache[this.currentIndex];
        };
    }

    public validate(): void {
        const hasAllFinished = this.imagesCache.every((img) => img.complete);

        if (hasAllFinished) {
            this.hasRenderFinished.next(true);
        }
    }

    public hasFinishedListener(): BehaviorSubject<boolean> {
        return this.hasRenderFinished;
    }
}